<template>
    <li>
        <slot name="cat-menu" :clickOpen="isOpen" :toggleProps="toggle"></slot>
    </li>
</template>

<script>
export default {
    props: ['active'],
    data() {
        return {
            isOpen: false,
        };
    },

    mounted() {
        this.isOpen = this.active;
    },

    methods: {
        toggle() {
            this.isOpen = !this.isOpen;
        },
    },
};
</script>

<style lang="scss" scoped>
.slide-down-enter {
    overflow: hidden;
    max-height: 0px;
    // padding: 0 10px;
}
.slide-down-enter-active {
    transition-duration: 0.3s;
    transition-timing-function: ease-in;
}
.slide-down-enter-to {
    max-height: 500px;
    overflow: hidden;
    // padding: 1rem 10px;
}
.slide-down-leave {
    max-height: 500px;
    overflow: hidden;
    // padding: 0 10px;
}
.slide-down-leave-active {
    transition-duration: 0.3s;
    transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}
.slide-down-leave-to {
    overflow: hidden;
    max-height: 0px;
    // padding: 1rem 10px;
}
</style>
